import React from 'react';
import { ArrowRight, Search, Sprout } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './hero.css';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="ankurit-hero" id="home">
      <div className="ankurit-hero__media" aria-hidden="true">
        <img src="/pictures/photo1.jpg" alt="" />
      </div>

      <div className="ankurit-hero__inner">
        <div className="ankurit-hero__copy">
          <span className="ankurit-hero__eyebrow">
            <Sprout size={16} />
            Direct plant commerce
          </span>

          <h1>Plants, farmers, and buyers on one simple marketplace.</h1>

          <p>
            Ankurit helps growers list nursery stock, reach verified buyers, and
            manage conversations without middlemen getting in the way.
          </p>

          <div className="ankurit-hero__actions">
            <button type="button" onClick={() => navigate('/products')} className="ankurit-button ankurit-button--primary">
              Browse plants
              <ArrowRight size={18} />
            </button>
            <button type="button" onClick={() => navigate('/search')} className="ankurit-button ankurit-button--secondary">
              <Search size={18} />
              Search market
            </button>
          </div>
        </div>

        <div className="ankurit-hero__panel" aria-label="Marketplace highlights">
          <div>
            <span>10k+</span>
            <p>farmers and nursery partners</p>
          </div>
          <div>
            <span>500+</span>
            <p>local markets connected</p>
          </div>
          <div>
            <span>24/7</span>
            <p>support for listings and orders</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
